export const pickDomainFromUrl = (url: string): string => {
  let result = url.replace('http://www.', '');
  result = result.replace('http://', '');
  result = result.replace('https://www.', '');
  result = result.replace('https://', '');
  result = result.split('/')[0];
  return result;
};
